<template>
  <div class="rounded w-full relative">
    <multiselect
      :multiple="true"
      :options="getList"
      :value="selected"
      @select="onSelect"
      @remove="onRemove"
      placeholder="Ürün seçiniz"
      label="name"
      track-by="id"
      selectLabel="EKLE"
      deselectLabel="KALDIR"
      :close-on-select="false"
      :clear-on-select="false"
    >
      <template slot="selection" slot-scope="{ values, isOpen }"
        ><span class="multiselect__single" v-if="values.length" v-show="!isOpen"
          >{{ values.length }} Ürün Seçildi</span
        ></template
      >
    </multiselect>
  </div>
</template>

<script>
//npm
import multiselect from "vue-multiselect";

//networking
import axios from "axios";
import { product } from "@/networking/urlmanager";
export default {
  name: "products-select",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    multiselect,
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      selected: null,
      List: [],
      load: false,
    };
  },
  methods: {
    onSelect(val) {
      this.selected.push(val);
    },
    onRemove(val) {
      const findIndex = this.selected.findIndex((r) => r.id == val.id);
      this.selected.splice(findIndex, 1);
    },
    getAll() {
      this.load = true;
      axios
        .get(product.getAllNotPagination, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then((result) => {
          this.List = result.data.data;
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
  },
  created() {
    this.selected = this.value;
    this.getAll();
  },
  computed: {
    getList() {
      const newList = this.List.map((item) => {
        const productIndex = this.selectedList.findIndex(
          (selectedProduct) => selectedProduct.productName === item.name
        );
        return { ...item, $isDisabled: productIndex >= 0 && true };
      });
      return newList;
    },
  },
  watch: {
    selected(val) {
      if (val && !this.load) {
        this.$emit("change", val);
      }
    },
    value(val) {
      if (val) this.selected = val;
    },
  },
};
</script>
